import { USER_PROFILE_LOCAL_STORAGE_KEY } from "../axios/constants";
import { clear, get, set } from "./local-storage";

export const setOnLocalStorage = (userProfile) => set(USER_PROFILE_LOCAL_STORAGE_KEY, userProfile);
export const getFromLocalStorage = () => get(USER_PROFILE_LOCAL_STORAGE_KEY);
export const clearOnLocalStorage = () => clear(USER_PROFILE_LOCAL_STORAGE_KEY);